import React from "react";

/** Personalised pass: the guest's name and how many places are reserved for them. */
export function GuestPass({ guest, passes = 1, greeting = "Hemos reservado", unitLabel, tone = "default", style }) {
  const label = unitLabel || (passes === 1 ? "pase" : "pases");
  const fg = tone === "onDark" ? "var(--fg-on-contrast)" : "var(--fg-primary)";
  const muted = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 66%, transparent)" : "var(--fg-secondary)";
  return (
    <div style={{
      position: "relative",
      display: "grid", justifyItems: "center", gap: "var(--sp-3)", textAlign: "center",
      padding: "var(--sp-7) var(--sp-5)",
      ...style,
    }}>
      <span style={{ position: "absolute", top: 0, left: "10%", right: "10%", height: 1, background: "linear-gradient(90deg, transparent, var(--rule-strong), transparent)" }} />
      <span style={{ position: "absolute", bottom: 0, left: "10%", right: "10%", height: 1, background: "linear-gradient(90deg, transparent, var(--rule-strong), transparent)" }} />
      <p style={{ margin: 0, fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body-l)", color: muted }}>Invitación especial para</p>
      <p style={{ margin: 0, fontFamily: "var(--font-flourish, var(--font-script))", fontSize: "var(--fs-display-s)", lineHeight: 1.25, color: "var(--accent)" }}>{guest}</p>
      <span style={{ width: 40, height: 1, background: "var(--rule-strong)", opacity: 0.5 }} />
      <p style={{ margin: 0, fontSize: "var(--fs-body-s)", color: muted }}>
        {greeting} <strong style={{ fontWeight: "var(--fw-medium)", color: "var(--accent)" }}>{passes} {label}</strong>
      </p>
    </div>
  );
}
